import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, HiddenFooter, SetAllMemberCheck } from '../../shared/message.event';
import { AuthenticationService } from '../shared/authentication.service';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { Encryption } from './../../shared/encryption';
import { UtilityFunctions } from '../../shared/utility-functions';
import { AuthGuard } from '../../shared/auth-guard';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-sign-in',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css'],
    providers: [
        AuthenticationService,
        MessageEvent,
        SignInEvent,
        RouterModule,
        LoaderEvent,
        FacilityListEvent,
        HiddenFooter,
        SetAllMemberCheck,
        AuthGuard
    ]
})
export class SigninComponent implements OnInit {
    public singleModel: string = '1';
    private stringConstants = CONSTANT_MESSAGES;
    private _router;
    private vendor = {
        emailId: '',
        password: ''
    };
    private validClassUserName;
    private validClassPassword;
    private rememberMeCheck;
    private popUpMessage = '';
    private popUp = true;
    private windowHeight = window.innerHeight;
    private height = 602;
    private top: string;
    private _appService;
    private noData = true;
    private appVersion: any;
    private pwdKey = '';
    private source = '';
    private utilityFunctions = new UtilityFunctions();

    constructor(private router: Router, private authService: AuthenticationService, private privateviewContainerRef: ViewContainerRef,
        private messageEvent: MessageEvent, private signInEvent: SignInEvent, private loaderEvent: LoaderEvent,
        private facilityListEvent: FacilityListEvent, private appService: AppService, private hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck,
        private authGuard: AuthGuard, private route: ActivatedRoute) {
        this._router = router;
        this.top = ((this.windowHeight - this.height) / 2) + 'px';
        this._appService = appService;
        this._appService.getAppVersion().then((result: any) => {
            this.appVersion = result.appVersion;
            this.pwdKey = result.ASE_KEY;
        });

    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.source = params['source'];
        });
        let vendorObj;
        vendorObj = this.authService.getRememberedVendor();
        if (vendorObj) {
            this.rememberMeCheck = true;
            this.vendor.emailId = vendorObj['emailId'];
            this.vendor.password = vendorObj['password'];
        } else {
            this.rememberMeCheck = false;
        }
        if (this.authGuard.sessionCheck() && this.authGuard.authenticateUser()) {
            this.authGuard.navigateUserToDefaultRoute();
        }
        this.emitTypeBroadcast();
    }

    /**
     * vendor sign in.
     *
     * @param vendor's email id and password
     *
     *
     * @response got signed in
     */
    signIn(popUpObj) {
        let encryption = new Encryption();
        let that = this;
        let validateFlag;
        let vendor = {};
        let vendorObjRemember;
        this.vendor.emailId = this.vendor.emailId.trim();
        validateFlag = this.validationSignIn('', '');
        let tempVendor = {
            'emailId': that.vendor.emailId,
            'password': that.vendor.password
        }
        if (validateFlag) {
            this.loaderEvent.fire(false);
            encryption.hash(tempVendor['password'])
                .then((hashed) => {
                    vendorObjRemember = this.authService.getRememberedVendor();
                    tempVendor.password = hashed;
                    that.authService.signIn(tempVendor).then((result: any) => {
                        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
                            that.popUp = false;
                            if (that.rememberMeCheck) {
                                localStorage.setItem('vendorRemember', btoa(JSON.stringify(that.vendor)));
                            } else {
                                localStorage.removeItem('vendorRemember');
                            }
                            vendor = result.vendor;
                            vendor['members'] = [];
                            localStorage.setItem('vendor', btoa(JSON.stringify(vendor)));
                            let id = (vendor['role'] === CONSTANT_VALUES.ROLE_STAFF && vendor['vendorId'] ? vendor['vendorId'] : vendor['_id']);
                            if (vendor['role'] == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
                                that._appService.getFacilityByClub(vendor['_id']);
                            } else if (vendor['role'] == CONSTANT_VALUES.SUPER_ADMIN) {
                                if (vendor['subVendors'].length > 0) {
                                    let subVendor = vendor['subVendors'][0];
                                    that._appService.getFacilityByClub(subVendor._id);
                                }
                            } else {
                                that._appService.getFacilityByClub(vendor['vendorId']);
                            }
                            if (this.source == 'loyalty') {
                                window.location.href = `${environment.appBaseUrl}/scan-qr`;
                                return;
                            }
                            if (that.authGuard.authenticateUser()) {
                                that.authGuard.navigateUserToDefaultRoute();
                            }
                        } else {
                            that.loaderEvent.fire(true);
                            that.popUp = true;
                            that.popUpMessage = result.message;
                            popUpObj.showChildModal();
                        }
                        that.loaderEvent.fire(true);
                    })
                        .catch((err) => {
                            console.log(err);
                            that.loaderEvent.fire(true);
                        });
                });
        } else {
        }

    }

    /**
     * function hide menu at sign in page by broadcaster
     */

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'none'
        };
        this.signInEvent.fire('none');
        this.hiddenFooter.fire(isShow);
    }

    /**
     * Validation on email id and password
     *
     * @param vendor's email id and password
     *
     * @response got error line for invalid parameters
     */
    validationSignIn(validateProperty, event) {
        let flag = true;
        switch (validateProperty) {
            case 'emailId':
                if (event && event.keyCode !== 9) {
                    if (this.vendor.emailId === '' || !this.utilityFunctions.validateEmail(this.vendor.emailId)) {
                        this.validClassUserName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validClassUserName = '';
                    }
                }
                break;
            case 'password':
                if (event && event.keyCode !== 9) {
                    if (this.vendor.password === '') {
                        this.validClassPassword = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    } else {
                        this.validClassPassword = '';
                    }
                }
                break;
            default:
                if (this.vendor.emailId === '') {
                    this.validClassUserName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;

                } else {
                    this.validClassUserName = '';
                }
                if (this.vendor.password === '') {
                    this.validClassPassword = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    flag = false;

                } else {
                    this.validClassPassword = '';
                }
        }
        return flag;
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/signin/signin.component.ts